import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Remittance from '../../models/Remittance'

export interface RemittanceListState extends PaginatedApiState {
  remittances?: Remittance[]
}

const RemittanceList = (state: RemittanceListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<RemittanceListState>('REMITTANCE_LIST')(state, action)
  }
}

export default RemittanceList
